import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Boutton from '../Boutton/Boutton';
import './SelectionChaise.css';

const mediaVariants = {
  rest: { y: 0, boxShadow: '0 0px 0px rgba(43, 36, 32, 0)' },
  hover: { y: -6, boxShadow: '0 26px 44px -18px rgba(43, 36, 32, 0.45)' },
};

const imageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.07 },
};

const tagVariants = {
  rest: { rotate: -7, scale: 1 },
  hover: { rotate: 0, scale: 1.06 },
};

const SelectionChaise = (props) => {
  const [quantite] = useState(1);
  const detailHref = `/${props.nom}/details/${props.id}`;

  return (
    <motion.div
      className="hd-chaircard-wrap mb-4"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="hd-chaircard">
        <Link className="hd-chaircard-media-link" to={detailHref}>
          <motion.div
            className="hd-chaircard-media"
            initial="rest"
            whileHover="hover"
            animate="rest"
            variants={mediaVariants}
            transition={{ duration: 0.35, ease: 'easeOut' }}
          >
            <motion.img
              src={props.image}
              alt={props.titre}
              className="hd-chaircard-image"
              variants={imageVariants}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />

            <motion.span
              className="hd-chaircard-tag"
              variants={tagVariants}
              transition={{ type: 'spring', stiffness: 320, damping: 16 }}
            >
              {props.prix} DT
            </motion.span>
          </motion.div>
        </Link>

        <div className="hd-chaircard-info">
          <Link to={detailHref} className="hd-chaircard-title-link">
            <h3 className="hd-chaircard-title">{props.titre}</h3>
          </Link>

          <div className="hd-chaircard-cta">
            <Boutton item={props} price={props.prix} quantite={quantite} />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SelectionChaise;
